import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class CoursesManangementVM extends InterActive{
    private specializations:{id:string , value:string }[] = []
    private levels:{id:string , value:string }[] = []
    private courses:{id:string , value:string }[] = []

    public get Specializations():{id:string , value:string}[] { return this.specializations }
    public get Levels():{id:string , value:string}[] { return this.levels }
    public get Courses():{id:string , value:string}[] { return this.courses }

    public load(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getCourseManagementLists()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.specializations && response.data.data.specializations.length>0){
                                    this.specializations = response.data.data.specializations.map(i=>({id:i.id , value:i.specialization}))
                                    this.levels = response.data.data.levels.map(i=>({id:i.id , value:i.level}))
                                }
                                this.update()
                            }
                        }
                    }
                }catch{

                }
            }
        )
    }

    public async delete(id:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        this.removeItem(id,dataType)
        try{
            const response = await ApiRequest.deleteItem(id, dataType)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }
    public async addItem(value:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        try{
            const response = await ApiRequest.addItem(value, dataType)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.pushItem(response.data.data.id , response.data.data.value , dataType)
                    }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }

    private removeItem(id:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        switch(dataType){
            case "التخصص": { this.specializations = this.specializations.filter(a=>(a.id != id));break; }
            case "المستوى":{ this.levels = this.levels.filter(a=>(a.id != id));break; }
            case "الكورس":{ this.courses = this.courses.filter(a=>(a.id != id));break; }
        }
        this.update()
    }
    private pushItem(id:string , value:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        switch(dataType){
            case "التخصص": {if(!this.specializations.includes({id:id , value:value})){ this.specializations.push({id:id , value:value}) } ;break; }
            case "المستوى":{ if(!this.levels.includes({id:id , value:value})){ this.levels.push({id:id , value:value}) } ;break; }
            case "الكورس":{ if(!this.courses.includes({id:id , value:value})){ this.courses.push({id:id , value:value}) } ;break; }
        }
        this.update()
    }
}